export default angular
  .module("ModifyCodeAliasCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ModifyCodeAliasController", [
    "$scope",
    "codeAliasData",
    "$state",
    "$modalInstance",
    "$modal",
    "$stateParams",
    "$http",
    "$rootScope",
    "$translate",
    "Scripts",
    "Aliases",
    "System",
    "$location",
    "modal",
    function (
      $scope,
      codeAliasData,
      $state,
      $modalInstance,
      $modal,
      $stateParams,
      $http,
      $rootScope,
      $translate,
      Scripts,
      Aliases,
      System,
      $location,
      modal,
    ) {
      $scope.loading = System.loading;
      $scope.searchString = "";
      $scope.codealias = codeAliasData;
      $scope.showAddNewCode = false;
      $scope.sortCodes = {};
      $scope.sortCodes.column = "CODE_SYSTEM";
      $scope.sortCodes.direction = false;
      $scope.groups = [
        { name: "Diagnosis", id: 1 },
        { name: "Drug", id: 3 },
        { name: "Procedure", id: 11 },
        { name: "Result", id: 5 },
        { name: "Risk", id: 13 },
        { name: "Vaccination", id: 14 },
      ];
      Scripts.loadCodeAliasScripts($scope.codealias.SYS_ID, (scripts) => {
        $scope.codealiasScripts = scripts;
      });
      System.loadAliasCodes($scope.codealias.SYS_ID, (aliasCodes) => {
        $scope.codealias.CODES = aliasCodes;
      });
      $scope.saveCodeAliasCode = function (code) {
        System.saveCode(code, () => {
          System.loadAliasCodes($scope.codealias.SYS_ID, (aliasCodes) => {
            $scope.codealias.CODES = aliasCodes;
          });
          System.loadAllCodesAliases("codes", (codes) => {
            $scope.availableCodes = codes;
          });
        });
      };

      const loadCodeSystems = () => {
        System.loadCodeSystems((data) => {
          $scope.codeSystems = data;
        });
      };

      $scope.addCodeAliasCode = function (code) {
        code.ALIAS_ID = $scope.codealias.SYS_ID;
        System.addCodeAliasCode(code, () => {
          System.loadAliasCodes($scope.codealias.SYS_ID, (aliasCodes) => {
            $scope.codealias.CODES = aliasCodes;
          });
        });
      };
      $scope.addNewCodeAliasCode = function (searchString) {
        const newCode = {
          ALIAS_ID: $scope.codealias.SYS_ID,
          CODE: searchString.$,
          CODE_SYSTEM_ID: ($scope.codeSystems
            .find(e => e.NAME === searchString.CODE_SYSTEM) || { ID: -1 })
            .ID,
        };
        System.addNewCodeAliasCode(newCode, () => {
          System.loadAliasCodes($scope.codealias.SYS_ID, (aliasCodes) => {
            $scope.codealias.CODES = aliasCodes;
          });
          System.loadAllCodesAliases("codes", (codes) => {
            $scope.availableCodes = codes;
          });
        });
      };
      $scope.removeCodeAliasCode = function (code) {
        code.ALIAS_ID = $scope.codealias.SYS_ID;
        System.removeCodeAliasCode(code, () => {
          System.loadAliasCodes($scope.codealias.SYS_ID, (aliasCodes) => {
            $scope.codealias.CODES = aliasCodes;
          });
        });
      };
      $scope.showAddCode = function () {
        $scope.showAddNewCode = !$scope.showAddNewCode;
        loadCodeSystems();
        System.loadAllCodesAliases("codes", (codes) => {
          $scope.availableCodes = codes;
        });
      };
      $scope.changeSorting = function (column) {
        if ($scope.sortCodes.column === column) {
          $scope.sortCodes.direction = !$scope.sortCodes.direction;
        } else {
          $scope.sortCodes.column = column;
          $scope.sortCodes.direction = false;
        }
      };
      $scope.openScriptURL = function (scriptID) {
        $rootScope.searchString = $scope.searchString;
        $location.path(`/script/${scriptID}`);
        $modalInstance.dismiss("cancel");
      };
      $scope.removeAliasFromScript = function (alias) {
        modal.openDelete(alias.NAME, "Code Alias from the script").result.then(() => {
          Scripts.deleteScriptCodeAlias(alias, () => {
            $modalInstance.close();
          });
        });
      };
      $scope.ok = function () {
        System.saveCodeAlias($scope.codealias, () => {
          if ($scope.isResultAlias()) {
            const { ALIAS_ID, CONVERSIONS, EDITOR_ID, ID, INTERNAL_UNIT, MAX_AGE, MAX_OBSERVATIONS, TIME_STAMP, VALIDATION } = $scope.codealias;
            const measurement = { ALIAS_ID, CONVERSIONS, EDITOR_ID, ID, INTERNAL_UNIT, MAX_AGE, MAX_OBSERVATIONS, TIME_STAMP, VALIDATION };
            Aliases.updateMeasurementByAliasId(ALIAS_ID, measurement);
          }
          $modalInstance.close();
        });
      };
      $scope.cancel = function () {
        $modalInstance.dismiss("cancel");
      };

      $scope.isResultAlias = () => {
        const resultGroup = ($scope.groups.find(g => g.name === "Result") || {}).id;
        return $scope.codealias && $scope.codealias.ALIAS_GROUP === resultGroup;
      };
    },
  ]);
